export enum CmNumericValidatorVariation {
	Positive = 'Positive',
	PositiveOrZero = 'PositiveOrZero',
	Negative = 'Negative',
	NegativeOrZero = 'NegativeOrZero',
	Integer = 'Integer'
}
